<fl-login
  [isAuthenticated]="isAuthenticated()"
  [isLoading]="isLoading()"
  [tenants]="tenants()"
  [version]="version()"
  (tenantLogin)="onTenantLogin($event)"
  (logout)="authFacade.logout()"
/>
